
import {ScreenChange} from '../lib/game';
import { GameConfig, GameStats, IScreenBase, userBalance, userInfos} from '../lib/definitions';

import {  BlockchainInfos, globalUserInfos } from '../lib/blockchainSession';
import { Dispatch, SetStateAction } from 'react';
import { ActiveNavLink } from '../ui/balance';


function defHandler(e: any){ return true;}

type EventFunc = (e: any) => boolean;

export class DomEvents {

    onMouseMove:EventFunc;
    onMouseDown:EventFunc;
    onMouseUp:EventFunc;
    onTouchMove:EventFunc;
    onTouchEnd:EventFunc;
    onKeyDown:EventFunc; 
    onKeyUp:EventFunc;
    constructor(){
        
        this.onMouseMove=defHandler;
        this.onMouseDown=defHandler;
        this.onMouseUp=defHandler;
        this.onTouchMove=defHandler;
        this.onTouchEnd=defHandler;
        this.onKeyDown=defHandler;
        this.onKeyUp=defHandler;
    }
}



export class ScreenBase implements IScreenBase{
    screenChanger: ScreenChange;
    engine:any;
    curEngine:any;
    glDomRef:any;
    renderMode:number;
    eventObject:DomEvents;
    name:string;
    userBalance:userBalance | null;
    userInfos:userInfos | null;
    blockchaininfos : BlockchainInfos | null;
    gameConfig: GameConfig;

    setactiveLinks:Dispatch<SetStateAction<ActiveNavLink>>;
    setuserinfos:Dispatch<SetStateAction<globalUserInfos>>;
    setBCInfos:Dispatch<SetStateAction<BlockchainInfos>>;
    setgameStats : Dispatch<SetStateAction<Array<GameStats> | null>>;
    settotalBonus : Dispatch<SetStateAction<number>>;
    

    constructor(engine:any, screenChanger: ScreenChange, renderMode : number, DAmmo : any, glDomRef : any, eventObject: DomEvents, blockchaininfos : BlockchainInfos, gameConfig : GameConfig, setactiveLinks:Dispatch<SetStateAction<ActiveNavLink>>, setuserinfos:Dispatch<SetStateAction<globalUserInfos>>, setBCInfos:Dispatch<SetStateAction<BlockchainInfos>>, setgameStats : Dispatch<SetStateAction<Array<GameStats> | null>>, settotalBonus : Dispatch<SetStateAction<number>>){
    
        this.blockchaininfos=blockchaininfos;
        this.eventObject = eventObject;
        this.screenChanger = screenChanger;
        this.curEngine = engine;
        this.renderMode = renderMode;
        this.glDomRef = glDomRef;
        this.userBalance = null;
        this.userInfos = null;
        this.gameConfig = gameConfig;
        
        this.setactiveLinks = setactiveLinks;
        this.setuserinfos = setuserinfos;
        this.setBCInfos = setBCInfos;
        this.setgameStats = setgameStats;
        this.settotalBonus = settotalBonus;
        this.name = 'base';
    }
    
    getName(){
        return this.name;
    }
    async load(){
        return true;
    }

    setUserInfos(userInfos:globalUserInfos, gameConfig:GameConfig)
    {
        this.userBalance = userInfos.balance;
        this.userInfos = userInfos.userInfos;
        this.gameConfig = gameConfig;
    }
    setBlockchainInfos(blockchaininfos : BlockchainInfos):void {
        this.blockchaininfos = blockchaininfos;
    }
    async restartLevel(){};
    start(){}
    stop(){}
    unload(){};
    initEngine(): void {}
    initEngineWebGPU(): void {}
}

